export default {
  state: {
    map: {
      init: false
    }
  },
  mutations: {
    setMapData (state, data) {
      for (let field in data) {
        state.map[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/map.js